import { PatientQuestionnaireControllerApi } from "../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../utils/utils";

/**
 * @author [Rajkumar Rathod]
 */
export const usePatientAssessmentExport = () =>
  useMutationWithLoading(
    async (params: { exportType: string; questionnaireIds: any }) =>
      new PatientQuestionnaireControllerApi(
        getConfigObject()
      ).exportPatientQuestionnaire(
        params.exportType,
        {
          questionnaireIds: params.questionnaireIds,
        },
        getXtenantId(),
        { responseType: "blob" }
      )
  );
